export const DATA_PLATFORM_API_URL = process.env.DATA_PLATFORM_API_URL || "";

export const FLAGSMITH_ENVIRONMENT_ID =
  process.env.NEXT_PUBLIC_FLAGSMITH_ENVIRONMENT_ID || "";

export const FLAGSMITH_API_URL = "https://flagsmith.mydeputy.ai/api/v1";
